module.exports = __webpack_public_path__ + "static/img/pc.bbb710a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/en/初中/pc.svg
// module id = NZ5A
// module chunks = 16